import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { Logger } from '../../util/logger/logger.service';
import { presentLoader } from '../../util/ion-util';
import { removeNonDigits } from 'src/app/util/mask-util';
import { LoadingController, NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';
import { fromE164, phoneValidationRegex, removeCountryCode, toE164 } from 'src/app/util/phone-util';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-resend-code',
  templateUrl: './resend-code.component.html',
  styleUrls: ['./resend-code.component.scss'],
})
export class ResendCodeComponent implements OnInit {

  public error: any;

  form: UntypedFormGroup;

  currPhone: string;

  editProfileFlow: boolean = false;

  static readonly COGNITO_PHONE_NUMBER_ATTRIBUTE = 'phone_number';

  constructor(private activatedRoute: ActivatedRoute,
              private formBuilder: UntypedFormBuilder,
              private navCtrl: NavController,
              private userService: UserService,
              private logger: Logger,
              private loadingCtrl: LoadingController,) {
  }
  async ngOnInit() {
    this.form = this.formBuilder.group({
      phone_number: ['', {validators: Validators.compose([Validators.required, Validators.pattern(phoneValidationRegex)]), updateOn: "change" }
    ]},
      { updateOn: "submit" }
    );
    this.activatedRoute.queryParams.subscribe((result) => {
      this.editProfileFlow = result['editProfileFlow'];
    });
    this.currPhone = (await this.userService.getCognitoUser(true)).attributes.phone_number;
    // Get the users phone number to display in input.
    if (!this.editProfileFlow) {
      const phone_number = removeCountryCode(removeNonDigits(('' + this.currPhone)));
      this.form.patchValue({ phone_number });
    }
  }

  async onSubmit() {
    this.logger.debug(this.form.value, this.form);

    if (this.form.invalid) {
      return;
    }

    const loader = await presentLoader(this.loadingCtrl);
    const e164Phone = toE164(this.form.value.phone_number);
    try {
      if (e164Phone === this.currPhone) {
        // re-verify current attribute
        await Auth.verifyCurrentUserAttribute(ResendCodeComponent.COGNITO_PHONE_NUMBER_ATTRIBUTE);
      } else {
        // update cognito phone number
        const updateUserAttributesParams = {};
        updateUserAttributesParams[ResendCodeComponent.COGNITO_PHONE_NUMBER_ATTRIBUTE] = e164Phone;
        await Auth.updateUserAttributes(await this.userService.getCognitoUser(), updateUserAttributesParams);
      }
      await loader.dismiss();
      if (this.editProfileFlow) {
        this.navCtrl.navigateForward(AppRoutingUtil.ACCOUNT_VERIFICATION_CODE, { queryParams: { editProfileFlow: true, newPhoneNumber: fromE164(e164Phone) } });
      } else if (e164Phone !== this.currPhone) {
        this.navCtrl.navigateBack(AppRoutingUtil.ACCOUNT_VERIFICATION_CODE, { queryParams: { newPhoneNumber: fromE164(e164Phone) } });
      } else {
        this.navCtrl.navigateBack(AppRoutingUtil.ACCOUNT_VERIFICATION_CODE);
      }
    } catch (error) {
      await loader.dismiss();
      this.logger.error(error);
      this.error = error;
    }
  }

  onDismiss() {
    if (this.editProfileFlow) {
      this.navCtrl.navigateBack(AppRoutingUtil.USER_INFO_PROFILE)
    }
  }

  getHeader(): string {
    return this.editProfileFlow ? 'Update phone' : 'Verify phone';
  }

  getTitle(): string {
    return this.editProfileFlow ? 'Enter phone' : 'Resend code';
  }

  getSubTitle(): string {
    return this.editProfileFlow ? 'What is your new phone number?' : 'Is your phone number correct?';
  }

  getSubText(): string {
    return 'We’ll send a text message to this number with a verification code.';
  }
}
